module.exports = __webpack_public_path__ + "assets/media/drift_salesloft_brand_logo.87ce03df.svg";